import { render, staticRenderFns } from "./Commentaries.vue?vue&type=template&id=f278b056&"
import script from "./Commentaries.vue?vue&type=script&lang=js&"
export * from "./Commentaries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports